import React from 'react';
import InputBasic from "../../components/input/InputBasic";
import TextAreaBasic from "../../components/input/TextAreaBasic";
import BtnsCreateFixed from "../../components/buttons/BtnsCreateFixed";
import Th_title from "../Th_title";
import {SelectComboBoxForCreate} from "../select/SelectComboBoxForCreate";

export const customStringOption=[
    {id:'INPUT', name:"INPUT"},
    {id:'TEXT', name:"TEXT"},
    {id:'DATE', name:"DATE"}
]

function RecursiveInfo({title, code, update, type}) {

    return (
        <div className={"flex flex-col m-5 border p-5"}>
            <section className="section display-table">
                <table className="w-full create-table">
                    <tbody>
                    <tr>
                        <Th_title title={title?? "자산그룹명"} className="fieldset-td" colspan={3} required={true}>
                        <InputBasic
                            target={"name"}
                            data={{data: code.code, setData: code.fnc}}
                        />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"상세설명"} className="fieldset-td" colspan={3} >
                            <TextAreaBasic
                                title={"상세설명"} target={"description"}
                                data={{data: code.code, setData: code.fnc}} colspan={3}
                            />
                        </Th_title>
                    </tr>
                    {
                        type && type === "string" &&
                        <tr>
                            <Th_title title={"타입"} className="fieldset-td" colspan={3} >
                                <SelectComboBoxForCreate target={"customType"} options={customStringOption}
                                                         data={{data: code.code, fnc: code.fnc}}
                                                         defaultValue={code.code?.customType} />
                            </Th_title>
                        </tr>
                    }

                    {
                        type !== "project" &&
                        <tr>
                            <Th_title title={"정렬순서"} className="fieldset-td" colspan={3} >
                                <InputBasic
                                    target={"orders"}
                                    data={{data: code.code, setData: code.fnc}} className={"w-50px"}
                                />
                            </Th_title>
                        </tr>
                    }
                    </tbody>
                </table>
            </section>
            <BtnsCreateFixed update={()=>update(code.code)}/>
        </div>
    );
}

export {RecursiveInfo};